import { httpWithAuth } from '~/clients';
import { GET_USER_PURCHASING } from '~/constants/endpoints';
import UserPurchaseData from './contracts/UserPurchaseData';

export default async function fetchUserPurchasing(
  controller?: AbortController
): Promise<UserPurchaseData> {
  const { data } = await httpWithAuth.get(GET_USER_PURCHASING, {
    signal: controller?.signal
  });

  return data;
}
